"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Adam Drda
 */


var WindowItemSimulationSupplierDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemSimulationSupplierDTOConverter, _DataObjectConverter_);

  function WindowItemSimulationSupplierDTOConverter() {
    _classCallCheck(this, WindowItemSimulationSupplierDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSimulationSupplierDTOConverter).apply(this, arguments));
  }

  return WindowItemSimulationSupplierDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemSimulationSupplierDTOConverter = WindowItemSimulationSupplierDTOConverter;